module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro@2-81a350261524aec2dad3d60b35a99b5c.jpg";